// Generated by Melange

import * as Caml_js_exceptions from "./caml_js_exceptions.js";

const anyToExnInternal = Caml_js_exceptions.internalToOCamlException;

function raiseError(str) {
  throw new Caml_js_exceptions.MelangeError(new Error(str).MEL_EXN_ID, new Error(str));
}

function raiseEvalError(str) {
  throw new Caml_js_exceptions.MelangeError(new EvalError(str).MEL_EXN_ID, new EvalError(str));
}

function raiseRangeError(str) {
  throw new Caml_js_exceptions.MelangeError(new RangeError(str).MEL_EXN_ID, new RangeError(str));
}

function raiseReferenceError(str) {
  throw new Caml_js_exceptions.MelangeError(new ReferenceError(str).MEL_EXN_ID, new ReferenceError(str));
}

function raiseSyntaxError(str) {
  throw new Caml_js_exceptions.MelangeError(new SyntaxError(str).MEL_EXN_ID, new SyntaxError(str));
}

function raiseTypeError(str) {
  throw new Caml_js_exceptions.MelangeError(new TypeError(str).MEL_EXN_ID, new TypeError(str));
}

function raiseUriError(str) {
  throw new Caml_js_exceptions.MelangeError(new URIError(str).MEL_EXN_ID, new URIError(str));
}

const $$Error$1 = Caml_js_exceptions.$$Error;

export {
  $$Error$1 as $$Error,
  anyToExnInternal,
  raiseError,
  raiseEvalError,
  raiseRangeError,
  raiseReferenceError,
  raiseSyntaxError,
  raiseTypeError,
  raiseUriError,
}
/* Caml_js_exceptions Not a pure module */
